import "@/assets/styles/globals.css";
import * as ewe from "@eyeo/webext-ad-filtering-solution/ui";
async function bootstrap() {
    ewe.sentry.start();
}
void bootstrap();
